@if (displayLinks(); as links) {
  <div
    class="flex flex--space-between white-bg surface-primary"
    [ngClass]="{
      'border rounded-large ps-large': showBorder(),
    }"
  >
    @for (link of links; track link.url) {
      <a
        class="flex flex--column flex--center align-center no-underline nordic-blue-900-text text-icon-primary font-body-medium-bold"
        [finLink]="link.url"
        [external]="link.external"
        (click)="clickLink.emit(link)"
      >
        @if (link.iconName) {
          <fcom-icon
            class="ms-small-b"
            [ngClass]="{
              'ms-xsmall-b': !isMobile() || showCompact(),
              'ms-small-b': isMobile() || !showCompact(),
              'icon-xlarge': !isMobile() && !showCompact(),
              'icon-large': isMobile() || showCompact(),
            }"
            [name]="link.iconName"
          />
        }
        {{ link.title }}
      </a>
    }
  </div>
}
